const options = {
  5: "bg-slate-800/5",
  10: "bg-slate-800/10",
  25: "bg-slate-800/25",
  50: "bg-slate-800/50",
  75: "bg-slate-800/75",
  90: "bg-slate-800/90",
  100: "bg-slate-800",
};

const from = {
  5: "from-slate-800/5",
  10: "from-slate-800/10",
  25: "from-slate-800/25",
  50: "from-slate-800/50",
  75: "from-slate-800/75",
  90: "from-slate-800/90",
  100: "from-slate-800",
};

export default function getBackgroundSlate800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
